import e from "../../utils/classNames.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/actionBarItem/ActionBarItemListSeparator.tsx
var n = ({ className: n, ...r }) => {
	let i = e("ActionBarItemListSeparator", n);
	return /* @__PURE__ */ t("hr", {
		...r,
		className: i
	});
};
//#endregion
export { n as default };

//# sourceMappingURL=ActionBarItemListSeparator.js.map